export default ({...props}) => {
  return `
        &[ap_type='deliverySummary'] {
            padding-top: 0px;
        }
        &[ap_type='deliveryDetails'] {
            padding-top: 0px;
        }
    `
}
